import 'css-chunksrc/client/scenes/taskStatus/status/styles.scss';export default {
  "main": "_main_1d5w4_1",
  "button": "_button_1d5w4_5",
  "reduced": "_reduced_1d5w4_19",
  "paragraph": "_paragraph_1d5w4_26",
  "square": "_square_1d5w4_33",
  "icon": "_icon_1d5w4_47",
  "menu": "_menu_1d5w4_55",
  "form": "_form_1d5w4_72",
  "visibleForm": "_visibleForm_1d5w4_76",
  "formSwitch": "_formSwitch_1d5w4_80",
  "hiddenFormSwitch": "_hiddenFormSwitch_1d5w4_86",
  "opened": "_opened_1d5w4_90",
  "readOnly": "_readOnly_1d5w4_95"
};